/**
 * SettingsModal - Game settings configuration
 */

import './SettingsModal.css';

export default function SettingsModal({ settings, onUpdate, onClose, onReset }) {
  return (
    <div className="settings-overlay" onClick={onClose}>
      <div className="settings-modal" onClick={e => e.stopPropagation()}>
        <div className="settings-header">
          <h2 className="settings-title">⚙️ Settings</h2>
          <button className="settings-close" onClick={onClose}>✕</button>
        </div>

        <div className="settings-content">
          {/* Voice toggle */}
          <div className="setting-item">
            <div className="setting-info">
              <span className="setting-label">🔊 Voice Feedback</span>
              <span className="setting-desc">Pip speaks instructions and praise</span>
            </div>
            <label className="toggle">
              <input
                type="checkbox"
                checked={settings.voiceEnabled}
                onChange={e => onUpdate({ voiceEnabled: e.target.checked })}
              />
              <span className="toggle-slider" />
            </label>
          </div>

          {/* Sound effects toggle */}
          <div className="setting-item">
            <div className="setting-info">
              <span className="setting-label">🎵 Sound Effects</span>
              <span className="setting-desc">Fun sounds when things happen</span>
            </div>
            <label className="toggle">
              <input
                type="checkbox"
                checked={settings.soundEffects}
                onChange={e => onUpdate({ soundEffects: e.target.checked })}
              />
              <span className="toggle-slider" />
            </label>
          </div>

          {/* Auto-listen toggle */}
          <div className="setting-item">
            <div className="setting-info">
              <span className="setting-label">🎤 Auto-Listen</span>
              <span className="setting-desc">Keep microphone on between words</span>
            </div>
            <label className="toggle">
              <input
                type="checkbox"
                checked={settings.autoListen}
                onChange={e => onUpdate({ autoListen: e.target.checked })}
              />
              <span className="toggle-slider" />
            </label>
          </div>

          {/* Speech rate slider */}
          <div className="setting-item setting-item--slider">
            <div className="setting-info">
              <span className="setting-label">🐢 Speech Speed 🐇</span>
              <span className="setting-desc">How fast Pip talks</span>
            </div>
            <div className="slider-container">
              <span className="slider-label">Slow</span>
              <input
                type="range"
                min="0.6"
                max="1.2"
                step="0.1"
                value={settings.speechRate}
                onChange={e => onUpdate({ speechRate: parseFloat(e.target.value) })}
                className="slider"
              />
              <span className="slider-label">Fast</span>
            </div>
          </div>
        </div>

        <div className="settings-footer">
          <button className="btn-reset" onClick={onReset}>
            🗑️ Reset Progress
          </button>
        </div>
      </div>
    </div>
  );
}
